function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';

// Local Definitions
import { useField } from 'formik';
import styleNames from '@pareto-engineering/bem/exports';
const baseClassName = styleNames.base;
const componentClassName = 'choice';

/**
 * This is the component description.
 */
const Choice = ({
  id,
  className: userClassName,
  style,
  name,
  label,
  labelClassName,
  labelStyle,
  value,
  multiple,
  validate,
  disabled,
  ...otherProps
}) => {
  const type = multiple ? 'checkbox' : 'radio';
  const [field] = useField({
    name,
    validate,
    type,
    value
  });
  return /*#__PURE__*/React.createElement("div", {
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    id: id,
    name: name
  }, field, otherProps, {
    value: value,
    disabled: disabled
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: [labelClassName, disabled && 'disabled'].filter(e => e).join(' '),
    style: labelStyle
  }, label));
};
Choice.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The input name.
   */
  name: PropTypes.string.isRequired,
  /**
   * The input label.
   */
  label: PropTypes.string.isRequired,
  /**
   * The input label class name.
   */
  labelClassName: PropTypes.string,
  /**
   * The input label styles.
   */
  labelStyle: PropTypes.objectOf(PropTypes.string),
  /**
   * The input value.
   */
  value: PropTypes.string.isRequired,
  /**
   * If the input should be multiple - checkbox
   */
  multiple: PropTypes.bool,
  /**
   * The input field validator function
   */
  validate: PropTypes.func,
  /**
   * Whether the radio or checkbox choice should be disabled
   */
  disabled: PropTypes.bool
};
export default Choice;